export const TECH_STACK = {
  typeScript: {
    src: 'https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/typescript/typescript.png',
    description: 'TypeScript'
  },
  node: {
    src: 'https://avatars.githubusercontent.com/u/9950313?s=200&v=4',
    description: 'NodeJs'
  },
  npm: {
    src: 'https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/npm/npm.png',
    description: 'Npm'
  },
  express: {
    src: 'https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/express/express.png',
    description: 'ExpressJs'
  },
  postgreSql: {
    src: 'https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/postgresql/postgresql.png',
    description: 'PostgreSQL'
  },
  mongoDb: {
    src: 'https://avatars.githubusercontent.com/u/45120?s=200&v=4',
    description: 'MongoDb'
  },
  heroku: {
    src: 'https://avatars.githubusercontent.com/u/23211?s=200&v=4',
    description: 'Heroku'
  },
  angular: {
    src: 'https://avatars.githubusercontent.com/u/139426?s=200&v=4',
    description: 'Angular'
  },
  fontAwesome: {
    src: 'https://avatars.githubusercontent.com/u/1505683?s=200&v=4',
    description: 'Font Awesome'
  },
  sass: {
    src: 'https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/sass/sass.png',
    description: 'Sass'
  },
  markdown: {
    src: 'https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/markdown/markdown.png',
    description: 'Markdown'
  },
  reactNative: {
    src: 'https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/react-native/react-native.png',
    description: 'React Native'
  }
};
